/** Polling an invoice while its payment settles: soon at first, then ever less often, and give up. */
export const PAYMENT_POLL = { firstMs: 3_000, factor: 1.6, maxMs: 30_000, stopAfterMs: 5 * 60_000 } as const;

/**
 * Delay before the next check, or false to stop. `attempt` counts the checks made since the
 * payment became pending (0 for the first), `elapsedMs` is the time since then.
 */
export function paymentPollDelay(attempt: number, elapsedMs: number): number | false {
  if (elapsedMs >= PAYMENT_POLL.stopAfterMs) return false;
  return Math.min(Math.round(PAYMENT_POLL.firstMs * PAYMENT_POLL.factor ** attempt), PAYMENT_POLL.maxMs);
}

/** The studio overview: a glance at what needs attention, not a live feed. */
export const OVERVIEW_POLL_MS = 60_000;
